module.exports = __webpack_public_path__ + "img/nordic_yes-nBC5myu.svg";